import { render, staticRenderFns } from "./polaris-input-category-search.vue?vue&type=template&id=fecf155c&"
import script from "./polaris-input-category-search.vue?vue&type=script&lang=js&"
export * from "./polaris-input-category-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports